"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLYGON_PROGRAM_IDS = exports.BNB_PROGRAM_IDS = exports.ETHEREUM_PROGRAM_IDS = void 0;
var types_1 = require("../common/types");
exports.ETHEREUM_PROGRAM_IDS = (_a = {},
    _a[types_1.ICluster.Mainnet] = "0x94d4646Bd307Bf91CB1893BC64d976BF9E60D9B2",
    _a[types_1.ICluster.Devnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _a[types_1.ICluster.Testnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _a[types_1.ICluster.Local] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _a);
exports.BNB_PROGRAM_IDS = (_b = {},
    _b[types_1.ICluster.Mainnet] = "0x94d4646Bd307Bf91CB1893BC64d976BF9E60D9B2",
    _b[types_1.ICluster.Devnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _b[types_1.ICluster.Testnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _b[types_1.ICluster.Local] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _b);
exports.POLYGON_PROGRAM_IDS = (_c = {},
    _c[types_1.ICluster.Mainnet] = "0x94d4646Bd307Bf91CB1893BC64d976BF9E60D9B2",
    _c[types_1.ICluster.Devnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _c[types_1.ICluster.Testnet] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _c[types_1.ICluster.Local] = "0x5Db7a43D20De64E3a3BC765334a477026FD13E7d",
    _c);
